import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { EmptyLayout } from "../../components/molecules";
import DataModelAnalyticsGraph from "./DataModelAnalyticsGraph";
import { actions } from "./dataModels.reducers";

const { setSelectedDataModelId } = actions;

const DataModelAnalytics = () => {
  const { dataModelId } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (dataModelId) dispatch(setSelectedDataModelId(dataModelId));
  }, [dispatch, dataModelId]);

  const apiUsage = true;

  return (
    <>
      {apiUsage ? (
        <>
          <DataModelAnalyticsGraph />
        </>
      ) : (
        <div className="content overflow-auto p-6 flex-1">
          <EmptyLayout
            title="No Analytics To Show"
            subTitle="No Api Requests Found "
            shouldShowButton={false}
          />
        </div>
      )}
    </>
  );
};
export default DataModelAnalytics;
